import { SET_EXTENSION_ID } from "./constants";

export default (state=null, action) => {
  if (action.type === SET_EXTENSION_ID) {
    return action.extensionID;
  }
  return state;
};
